// 只能输入正整数(包括0)或小数，小数只保留指定位数；使用示例：v-positivePoint="2"
export default {
  bind(el, binding, vnode) {
    // 获取动态的小数位数，默认值为 2
    const precision = binding.value !== undefined ? parseInt(binding.value) : 2;

    // 找到底层的 input 元素（兼容 el-input）
    const input = el.tagName === "INPUT" ? el : el.querySelector("input");
    if (!input) return;

    el.handleInput = event => {
      let value = event.target.value;

      // 1. 过滤掉非数字和点
      value = value.replace(/[^\d.]/g, "");

      // 2. 确保只有一个小数点
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");

      // 3. 限制第一位不能是小数点
      if (value.indexOf(".") === 0) {
        value = value.substring(1);
      }

      // 4. 限制第一位是0时，第二位必须是点
      if (value.length > 1 && value[0] === "0" && value[1] !== ".") {
        value = value.substring(1);
      }

      // 5. 动态限制小数位数
      if (precision > 0) {
        const reg = new RegExp(`^(\\d+)\\.(\\d{0,${precision}}).*$`);
        if (value.includes(".")) {
          value = value.replace(reg, "$1.$2");
        }
      } else {
        // 如果 precision 为 0，则不允许输入小数点（整数模式）
        value = value.replace(".", "");
      }

      // 只有当值发生变化时才更新，防止光标跳动
      if (event.target.value !== value) {
        event.target.value = value;

        // 手动触发 input 事件更新 v-model
        if (vnode.componentInstance) {
          vnode.componentInstance.$emit("input", value);
        } else {
          input.dispatchEvent(new Event("input"));
        }
      }
    };

    // 建议使用 input 事件替代 keyup，能更好处理右键粘贴和中文输入法
    input.addEventListener("input", el.handleInput);
  },
  unbind(el) {
    const input = el.tagName === "INPUT" ? el : el.querySelector("input");
    if (input && el.handleInput) {
      input.removeEventListener("input", el.handleInput);
    }
  },
};
